import React from "react";
import { connect } from "react-redux";

const Spinner = ({ display }) => {
	return (
		<svg
			style={{
				display,
				height: "15em",
				width: "15em",
				margin: "auto",
				color: "rgb(234, 97, 28)",
			}}
			className="animate-spin"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
		>
			<circle
				className="opacity-25"
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="2"
			></circle>
			<path
				className="opacity-75"
				fill="currentColor"
				d="m 2.996356,11.991985 c 0,-4.4182781 3.5530522,-8.9743205 8.98754,-8.9743205 V 0.99843933 c -5.5809015,0 -10.9811855,4.37101957 -10.9811855,10.99801967 z m 2.2301171,5.936222 C 3.9346869,16.468776 2.9929617,13.940995 2.996356,11.991985 l -1.9936455,0.0045 c 0.046135,2.893468 0.9738393,5.19937 2.6602844,7.179939 z"
			></path>
		</svg>
	);
};

const LoadingContent = ({ fixed, resize }) => {
	if (fixed)
		return (
			<div style={{ display: "flex", alignContent: "center", width: resize ? "calc(100vw - 230px)" : "100vw" }}>
				<Spinner display={"block"} />
			</div>
		);

	return (
		<div className="spinner-container">
			<Spinner />
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		resize: state.sidebar.show,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoadingContent);
